import { BorderRadius, Colors, Spacing } from '@lichtblick/theme';
import styled from 'styled-components';
import { Text } from '../Text';
export const StyledChip = styled.span`
  background-color: ${({ $background, theme })=>$background ?? (theme.primary || Colors.Black)};
  border-radius: ${BorderRadius.S};
  cursor: ${({ onClick })=>onClick ? 'pointer' : 'auto'};
  display: inline-block;
  padding: ${Spacing['3Xs']} ${Spacing.Xxs};
`;
export const Label = styled(Text).attrs({
    size: 'Xs'
})`
  color: ${({ $color, theme })=>$color ?? (theme.contrast || Colors.White)};
`;

//# sourceMappingURL=Chip.styles.js.map